import { createTheme } from '@mui/material/styles';
import { DEFAULT_THEME_COLOR, lightenHex, normalizeThemeColor } from './themeColors.js';

export function buildTheme(mode, primaryColor = DEFAULT_THEME_COLOR) {
  const basePrimary = normalizeThemeColor(primaryColor);
  const primaryMain = mode === 'dark' ? lightenHex(basePrimary, 0.32) : basePrimary;

  return createTheme({
    palette: {
      mode,
      primary: { main: primaryMain },
      secondary: { main: '#d59b3d' },
      background: mode === 'dark'
        ? { default: '#0d1715', paper: '#14231f' }
        : { default: '#f4f7f6', paper: '#ffffff' }
    },
    shape: { borderRadius: 12 },
    typography: {
      fontFamily: '"Inter", "Segoe UI", sans-serif',
      h4: { fontWeight: 750 },
      h5: { fontSize: '1.5rem', lineHeight: 1.3, fontWeight: 700 },
      h6: { fontWeight: 700 },
      button: { fontWeight: 650, textTransform: 'none' }
    },
    components: {
      MuiCard: { styleOverrides: { root: { boxShadow: '0 8px 28px rgba(16,60,53,.08)' } } },
      MuiButton: {
        defaultProps: { disableElevation: true, size: 'medium' },
        styleOverrides: { root: { minHeight: 40 } }
      },
      MuiTextField: { defaultProps: { size: 'small' } },
      MuiFormControl: { defaultProps: { size: 'small' } },
      MuiDialogTitle: {
        styleOverrides: {
          root: ({ theme }) => ({
            backgroundColor: theme.palette.primary.main,
            color: theme.palette.primary.contrastText,
            fontSize: '1.25rem',
            fontWeight: 700,
            padding: '12px 20px'
          })
        }
      },
      MuiDialogContent: { styleOverrides: { root: { paddingTop: 16 } } },
      MuiTableHead: {
        styleOverrides: {
          root: ({ theme }) => ({ backgroundColor: theme.palette.primary.main })
        }
      },
      MuiTableCell: {
        styleOverrides: {
          head: ({ theme }) => ({
            color: theme.palette.primary.contrastText,
            fontWeight: 700
          })
        }
      }
    }
  });
}
